export default "__VITE_ASSET__RqwpD4tr__"